'use client';

import { useState } from 'react';
import dynamic from 'next/dynamic';
import { IconPlay } from '@/components/icons/IconPlay';
import type { HeroShowreel } from './Hero.types';

// The site's one video modal, which pulls in the dialog primitive and the
// player markup — only the visitors who actually press play ever need it.
const UiMediaLightbox = dynamic(() => import('@/components/ui/UiMediaLightbox').then((m) => m.UiMediaLightbox), {
    ssr: false,
});

type HeroShowreelButtonProps = {
    showreel: HeroShowreel;
};

/**
 * Opens the showreel. Kept apart from the modal so the hero's above-the-fold
 * markup stays server-rendered and only this button hydrates.
 */
export function HeroShowreelButton({ showreel }: HeroShowreelButtonProps) {
    const [isOpen, setIsOpen] = useState(false);
    const [isMounted, setIsMounted] = useState(false);

    return (
        <>
            <button
                type="button"
                className="btn btn-primary hero__showreel"
                onClick={() => {
                    setIsMounted(true);
                    setIsOpen(true);
                }}
                onPointerEnter={() => setIsMounted(true)}
                onFocus={() => setIsMounted(true)}
            >
                <span className="hero__showreel-chip" aria-hidden="true">
                    <IconPlay />
                </span>
                {showreel.label}
            </button>

            {isMounted ? (
                /* The Mediathek's lightbox, with the showreel in it — the same
                   box, caption and close button, because there is only the one.
                   No title above the caption line: a showreel is the one thing
                   it says it is, so the label goes on the marked line where a
                   tile puts its Geschäftsbereich. */
                <UiMediaLightbox
                    video={showreel.video}
                    poster={showreel.poster}
                    area={showreel.meta ? { label: showreel.meta } : undefined}
                    open={isOpen}
                    onClose={() => setIsOpen(false)}
                    closeLabel="Showreel schließen"
                />
            ) : null}
        </>
    );
}
